import React from "react";
import { connect, useSelector } from "react-redux";
import headerGraphic from "../../../assets/images/error-illustration.svg";
import { clearError } from "../../../state/mode/mode.actions";
import { Localized } from "../../../strings";
import { managementPortalBillingUrl } from "../../../utils/management.portal/management.portal.url.selectors";
import { openManagementPortal } from "../../../utils/management.portal/openManagementPortal";
import { ErrorDialogWithImage } from "./ErrorDialogWithImage";

const mapDispatchToProps = {
  clearError,
};

type CreditLimitReachedDialogProps = typeof mapDispatchToProps;

export const CreditLimitReachedDialog: React.FC<
  CreditLimitReachedDialogProps
> = ({ clearError }) => {
  const strings = Localized.object("CREDIT_LIMIT_REACHED_DIALOG");
  const billingUrl = useSelector(managementPortalBillingUrl);

  const redirectToBillingPage = () => {
    openManagementPortal(billingUrl);
    clearError();
  };

  return (
    <ErrorDialogWithImage
      buttonCustomStyles={{
        backgroundColor: "var(--global--attention--Background)",
        color: "var(--global--text--Color)",
      }}
      buttonText={strings.BUTTON_TEXT}
      imageUrl={headerGraphic}
      onButtonClick={redirectToBillingPage}
      onCancel={clearError}
      showExternalLinkSymbol={true}
      title={strings.TITLE}
    />
  );
};

export default connect(undefined, mapDispatchToProps)(CreditLimitReachedDialog);
